import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import { DataGrid } from '@mui/x-data-grid';

import { LocalizationContext } from '../../../../../AppContext';
import Toolbar from './AgreementcategoriesTableToolbar';
import ColumnDefinition from './AgreementcategoriesTableColumnDefinition';
import RowsMapper from './AgreementcategoriesTableRowsMapper';
import localization from './AgreementcategoriesTable.local';

export default function AgreementcategoriesTable({
  agreementcategories,
  agreements,
  onRowClick,
  onAddClick,
  onStatusesClick,
}) {
  const local = localization[useContext(LocalizationContext)];
  const [rows, setRows] = useState();
  const [columns, setColumns] = useState();

  useEffect(() => setColumns(ColumnDefinition(local)), []);
  useEffect(() => setRows(RowsMapper(local, agreementcategories, agreements)), [agreementcategories, agreements]);

  return (
    <Paper sx={{ height: '100%' }}>
      { columns && rows && (
        <DataGrid
          sx={{ height: '100%' }}
          rows={rows}
          columns={columns}
          onRowClick={({ row }) => onRowClick(row.id)}
          components={{ Toolbar }}
          componentsProps={{ toolbar: { local, onAddClick, onStatusesClick } }}
        />
      )}
    </Paper>
  );
}

AgreementcategoriesTable.propTypes = {
  agreementcategories: PropTypes.arrayOf(PropTypes.shape({})),
  agreements: PropTypes.arrayOf(PropTypes.shape({})),
  onRowClick: PropTypes.func.isRequired,
  onAddClick: PropTypes.func.isRequired,
  onStatusesClick: PropTypes.func.isRequired,
};

AgreementcategoriesTable.defaultProps = {
  agreementcategories: undefined,
  agreements: undefined,
};
